import React from 'react';
import { Html } from '@react-three/drei';

interface FixedArrowProps {
  position: [number, number, number];
}

const FixedArrow: React.FC<FixedArrowProps> = ({ position }) => {
  return (
    <group position={position}>
      <Html position={[0, 0, 0]}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          transform: 'translate(-50%, -100%)',
          pointerEvents: 'none', // Evita que a seta bloqueie cliques
        }}>
          <div style={{
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            background: 'rgba(255, 215, 0, 0.2)',
            border: '2px solid rgba(255, 215, 0, 0.6)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            animation: 'pulse 1.5s infinite',
            boxShadow: '0 0 15px rgba(255, 215, 0, 0.5)',
            zIndex: 1000, // Garantir que a seta fique acima de outros elementos
          }}>
            <div style={{
              width: '15px',
              height: '15px',
              borderRight: '3px solid rgba(255, 215, 0, 0.9)',
              borderBottom: '3px solid rgba(255, 215, 0, 0.9)',
              transform: 'rotate(45deg) translateY(-2px)',
            }}></div>
          </div>
          <style>{`
            @keyframes pulse {
              0% { transform: scale(1); opacity: 0.8; }
              50% { transform: scale(1.1); opacity: 1; }
              100% { transform: scale(1); opacity: 0.8; }
            }
          `}</style>
        </div>
      </Html>
    </group>
  );
};

export default FixedArrow;
